import { bindable } from 'aurelia-framework';

class NewJobForm {
  @bindable loading = false;
  @bindable variants = [];
  @bindable operationId = null;
  @bindable onSave = () => {};
  mediaNumberOptions = ['5', '10', '20', '50', '100', 'all'].map(
    (number) => ({ id: number, label: number }),
  );
  variantOptions = [];
  mediaNumber = null;
  variant = null;
  onMediaNumberChange(item) {
    this.mediaNumber = item;
  }
  onVariantChange(item) {
    this.variant = item;
  }
  operationIdChanged() {
    [this.mediaNumber] = this.mediaNumberOptions;
    if (this.variantOptions.length) {
      [this.variant] = this.variantOptions;
    }
  }
  save($event) {
    $event.preventDefault();
    this.onSave({
      variant: this.variant.id,
      mediaNumber: this.mediaNumber.id,
    });
  }
  variantsChanged() {
    this.variantOptions = this.variants.map((variant) => ({
      id: variant,
      label: variant,
    }));
    if (!this.variant) {
      [this.variant] = this.variantOptions;
    }
  }
}

export { NewJobForm };
